module.exports = __webpack_public_path__ + "media/instagramLogo.0e84d592.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instagramLogo.png
// module id = ./src/assets/instagramLogo.png
// module chunks = 0